import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { locale, loadMessages } from "devextreme/localization";
// @ts-ignore
import esMessages from "devextreme/localization/messages/es.json";

@Component({
  // tslint:disable-next-line
  selector: "body",
  template: ` <app-spinner></app-spinner>
    <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {
    loadMessages(esMessages);
    locale(navigator.language);
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
  // ngOnInit() {
  //   this.router.events.subscribe((evt) => {
  //     if (!(evt instanceof NavigationEnd)) {
  //       return;
  //     }
  //     window.scrollTo(0, 0);
  //   });
  // }
}
